module.exports = __webpack_public_path__ + "static/media/rechtsberatung.f1499a25.svg";